import React, { useState } from 'react'; // Import React and the useState hook
import { signInWithEmailAndPassword } from 'firebase/auth'; // Import function to sign in with email and password
import { doc, getDoc } from 'firebase/firestore'; // Import functions to get Firestore documents
import { auth, db } from '../firebase'; // Make sure db is imported correctly

const GetAuth = ({ setUser }) => {
  const [email, setEmail] = useState(''); // State to hold the email input
  const [password, setPassword] = useState(''); // State to hold the password input
  const [error, setError] = useState(''); // State to hold error messages
  const [loading, setLoading] = useState(false); // State to handle loading state

  // Handler for login form submission
  const handleLogin = async (event) => {
    event.preventDefault(); // Prevent default form submission behavior
    setLoading(true); // Set loading state to true

    try {
      // Sign in with email and password
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user; // Get the authenticated user

      // Fetch user data from Firestore
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (userDoc.exists()) {
        // If the user document exists, set the user state with the user's data
        setUser({ uid: user.uid, ...userDoc.data() });
      } else {
        console.log('No such document!'); // Log if the user document does not exist
      }
    } catch (error) {
      // Set error message if login fails
      setError('Please enter correct info to login to admin panel');
    } finally {
      setLoading(false); // Set loading state to false
    }
  };

  return (
    <div className="auth-container">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        {/* Email input field */}
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
        </div>

        {/* Password input field */}
        <div>
          <label>Password:</label>
          <input
            type="password"
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
        </div>
        
        {/* Display error message if there is an error */}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {/* Submit button, disabled if loading */}
        <button type="submit" disabled={loading}>
          {loading ? <div className="loader"></div> : 'Login'} {/* Show loader when loading */}
        </button>
      </form>
    </div>
  );
};

export default GetAuth;
